import Vue from 'vue'
import App from './App.vue'
import router from './router'

// import '@/style/color.scss'
// element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// eventsBus 事件总线
const eventBus = new Vue({})
Vue.prototype.$bus = eventBus

Vue.use(ElementUI)
Vue.config.productionTip = false

const vue = new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')

export default vue
